import { render, staticRenderFns } from "./ShowResults.vue?vue&type=template&id=e4a1f976&"
import script from "./ShowResults.vue?vue&type=script&lang=js&"
export * from "./ShowResults.vue?vue&type=script&lang=js&"
import style0 from "./ShowResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports